module.exports = "mutation($id: [Int!]) {\n    deleteMJKey(keys: $id)\n}\n"